import { Api } from '../Api';
export const getFuelPriceTracker = async () => {
    try {
        const result = await Api.get(`/fuel-price/latest`);
        return result;
    } catch (error) {
        return error;
    }
};
export const getElectricityPriceTracker = async () => {
    try {
        const result = await Api.get(`/electricity-price/latest`);
        return result;
    } catch (error) {
        return error;
    }
};

export interface IToolsPageContent {
    name: string;
    description: string;
    content: Array<{ lang: string; description: string }>;
}
export const getToolPageContent = async (slug: string) => {
    try {
        const result = await Api.get(`/tools-page-content/${slug}`);
        return result;
    } catch (error) {
        return error;
    }
};
